<template>
  <div class="flex justify-center align-middle">
    <div class="relative h-1/2 w-full border-b border-primary">
      <div
        v-if="left"
        class="absolute -bottom-2 left-0.5 h-4 w-4 -rotate-45 border-l border-t border-primary"
      ></div>
      <div
        v-if="right"
        class="absolute -bottom-2 right-0.5 h-4 w-4 rotate-45 border-r border-t border-primary"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  left?: boolean;
  right?: boolean;
}>();
</script>
